import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHttpClient } from '../global.http.client';
import { IPage } from '../models/common/paging';
import { AwardDto, CompetitorModalSearchModel } from '../models/competitors/competitor.models';
import { BaseService } from './base.service';
import { ISearchService } from './search.service';

@Injectable()
export class CompetitorModalService extends BaseService implements ISearchService<CompetitorModalSearchModel, AwardDto> {
    constructor(http: GlobalHttpClient) {
        super(http);
    }

    search(request: CompetitorModalSearchModel): Observable<IPage<AwardDto>> {
        return this.http.post<IPage<AwardDto>>('competitors/getAwardsForCompany', request);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/competitor.modal.service.ts